import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

// Material
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

// Services
import { PermitService } from "@shared/services/permitService/permitService.service";

// Interfaces
import { Permissions } from '@shared/interfaces/Permissions';

@Component({
  selector: "app-home",
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, RouterModule],
  templateUrl: "./home.component.html",
  styleUrls: ["../../style.scss"],
  styles: [
    `
      :host {
        display: block;
        position: absolute;
        inset: 0;
        overflow-y: auto;
      }
    `,
  ],
})
export class HomeComponent {

  permissions: Permissions;
  isAdmin = false;

  constructor(
    private readonly permitService: PermitService
  ) {}

  ngOnInit() {
    this.isAdmin = this.permitService.getIsAdmin;
    this.permitService.getPermisos().subscribe(permissions => {
      this.permissions = permissions;
    })
  }

}
